import { createContext, useContext, useRef } from "react"
import { useMotionValue } from "framer-motion"
//import useScrollLock from "hooks/useScrollLock"
import { rafDelay } from "./utils"
//import { useNav } from "components/nav-v2/Wrapper"

const LEGAL_DISCLAIMER_KEY = "rlx-legal-disclaimer"

export function readLegalDisclaimer() {
  const ss = window.sessionStorage
  if (!ss) return -1
  return ss.getItem(LEGAL_DISCLAIMER_KEY) ?? -1
}

export function writeLegalDisclaimer(v) {
  const ss = window.sessionStorage
  if (!ss) return v
  ss.setItem(LEGAL_DISCLAIMER_KEY, v)
}

export const Context = createContext()

export const ConfiguratorProvider = ({ children }) => {
  //  const scrollLock = useScrollLock()
  //  const nav = useNav()
  //  const navMainLock = useRef(null)
  //  const navSubLock = useRef(null)
  const route = useMotionValue(null)
  const launched = useMotionValue(false)
  const legal_disclaimer_state = useMotionValue(process.browser ? +readLegalDisclaimer() : 0)
  const fromui = useMotionValue(false)
  const bkgfromrv = useMotionValue("")
  const cta = useRef(null)
  const page_type = useRef("all-model")

  function headerize(el) {
    return new Promise(resolve => {
      process.browser && document.querySelector("html").setAttribute("data-cfg", true)
      //      nav.main.bar.motion.pinned.set(0)
      //      scrollLock.lock(el)
      //      navMainLock.current = nav.main.lock.request(0)
      //      navSubLock.current = nav.sub.lock.request(0)
      rafDelay(() => {
        el?.classList.add("headerized")
        rafDelay(resolve)
      })
    })
  }

  function unheaderize(el) {
    return new Promise(resolve => {
      process.browser && document.querySelector("html").removeAttribute("data-cfg")
      el?.classList.remove("headerized")
      //      nav.main.bar.motion.pinned.set(1)
      //      if (typeof navMainLock.current === "function") navMainLock.current()
      //      if (typeof navSubLock.current === "function") navSubLock.current()
      //      scrollLock.unlock(el)
      rafDelay(() => {
        rafDelay(resolve)
      })
    })
  }

  return <Context.Provider value={{ route, launched, legal_disclaimer_state, fromui, bkgfromrv, headerize, unheaderize, cta, page_type }}>{children}</Context.Provider>
}

export const useConfigurator = () => useContext(Context)
